import { BookOpen, Download, ExternalLink, Sparkles } from "lucide-react";
import { Button } from "../ui/button";

const PDF_URL = `${process.env.REACT_APP_BACKEND_URL}/api/docs/user-guide.pdf`;
const HTML_URL = `${process.env.REACT_APP_BACKEND_URL}/api/docs/user-guide.html`;

/**
 * Tarjeta con accesos directos a la guía de usuario en PDF y HTML.
 *
 * Mostrar en Ajustes → Ayuda (y enlazar también desde sidebar y footer).
 */
export default function UserGuideCard() {
  return (
    <div
      className="border rounded-xl p-6 space-y-4"
      data-testid="user-guide-card"
    >
      <div className="flex items-start gap-4">
        <div className="w-10 h-10 rounded-lg bg-indigo-600 text-white flex items-center justify-center flex-shrink-0">
          <BookOpen className="w-5 h-5" />
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="font-semibold text-base">Guía de usuario completa</h3>
          <p className="text-sm text-muted-foreground">
            Manual paso a paso con todas las funcionalidades, escenarios reales y diagramas de
            flujo. Ideal para formar a nuevos miembros del equipo.
          </p>
          <div className="text-xs text-muted-foreground mt-2 flex flex-wrap gap-x-4 gap-y-1">
            <span>📄 24 páginas</span>
            <span>🎯 Para Owner, Encargado, Camarero y Cocina</span>
            <span>📊 7 diagramas de flujo</span>
          </div>
        </div>
      </div>

      <div className="flex flex-wrap gap-2 pt-2 border-t">
        <Button
          asChild
          className="bg-indigo-600 hover:bg-indigo-700 text-white"
          data-testid="user-guide-download-pdf"
        >
          <a href={PDF_URL} download="MenuGenius_Guia_Usuario.pdf">
            <Download className="w-4 h-4 mr-1.5" />
            Descargar PDF
          </a>
        </Button>
        <Button
          asChild
          variant="outline"
          data-testid="user-guide-open-html"
        >
          <a href={HTML_URL} target="_blank" rel="noopener noreferrer">
            <ExternalLink className="w-4 h-4 mr-1.5" />
            Ver en el navegador
          </a>
        </Button>
      </div>

      <div className="text-xs bg-violet-50 border border-violet-200 rounded-lg px-3 py-2 flex items-start gap-2">
        <Sparkles className="w-3.5 h-3.5 text-violet-600 mt-0.5 flex-shrink-0" />
        <span className="text-violet-800">
          <strong>Tip:</strong> imprime el PDF y déjalo en cocina o en la oficina para consulta
          rápida del equipo. La versión web tiene los diagramas con zoom interactivo.
        </span>
      </div>
    </div>
  );
}
